import { brandColors } from 'front-end/../shared/basicPalette'
import { ButtonGroup, ButtonOutline } from 'front-end/src/components'
import { EventModelAsStudent } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { isEventFull } from 'front-end/src/pages/manage-events/eventUtils'
import React from 'react'

import { Trans } from '@lingui/macro'

import { isRegistrationClosed } from '../event-attendance/EventAttendance'
import {
  useCancelAttendanceMutation,
  useChangeStatusIn3dPartyCalendarsMutation,
  useRegisterToAttendMutation
} from '../event-attendance/EventAttendance.codegen'
import { ButtonGroupProps } from '@chakra-ui/react'
import { notification } from 'front-end/src/components/common/notifications/Notifications'

export const RSVPButton = ({
  event,
  refetch,
  ...rest
}: ButtonGroupProps & {
  event: EventModelAsStudent
  refetch: () => void
}) => {
  const [RegisterToAttendDocument, { loading: loadingRegister }] =
    useRegisterToAttendMutation({
      onCompleted: refetch,
      onError: (e) => {
        notification.error(e.message)
      }
    })

  const [CancelAttendanceDocument, { loading: loadingCancel }] =
    useCancelAttendanceMutation({
      onCompleted: refetch,
      onError: (e) => {
        notification.error(e.message)
      }
    })
  const [
    ChangeStatusIn3dPartyCalendarsDocument,
    { loading: loadingChangeStatusCalendar }
  ] = useChangeStatusIn3dPartyCalendarsMutation({
    onCompleted: refetch,
    onError: (e) => {
      notification.error(e.message)
    }
  })

  const isNotAttending = event?.currentUserInvitee?.attending === false

  return (
    <ButtonGroup
      isAttached
      cursor={isRegistrationClosed(event) ? 'no-drop' : 'default'}
      {...rest}
    >
      <ButtonOutline
        minW="70px"
        backgroundColor={
          event?.currentUserInvitee?.attending === true
            ? brandColors.green[700]
            : 'transparent'
        }
        color={
          event?.currentUserInvitee?.attending === true
            ? brandColors.white
            : brandColors.grey[700]
        }
        onClick={async (ev) => {
          ev.stopPropagation()
          if (event?.currentUserInvitee?.attending === true) {
            return
          }
          await RegisterToAttendDocument({
            variables: { eventId: event.id }
          })
          await ChangeStatusIn3dPartyCalendarsDocument({
            variables: { eventId: event.id, attending: true }
          })
          await refetch()
        }}
        disabled={
          isRegistrationClosed(event) ||
          (isEventFull(event) && (!event?.currentUserInvitee || isNotAttending))
        }
        isLoading={loadingRegister || loadingChangeStatusCalendar}
        dataTest="YesButton"
      >
        <Trans>Yes</Trans>
      </ButtonOutline>
      <ButtonOutline
        borderLeft="0"
        minW="70px"
        backgroundColor={isNotAttending ? brandColors.red[500] : 'transparent'}
        color={isNotAttending ? brandColors.white : brandColors.grey[700]}
        onClick={async (ev) => {
          ev.stopPropagation()
          if (isNotAttending) {
            return
          }
          await CancelAttendanceDocument({
            variables: { eventId: event.id }
          })
          await ChangeStatusIn3dPartyCalendarsDocument({
            variables: { eventId: event.id, attending: false }
          })
          await refetch()
        }}
        isLoading={loadingCancel || loadingChangeStatusCalendar}
        disabled={isRegistrationClosed(event)}
        dataTest="NoButton"
      >
        <Trans>No</Trans>
      </ButtonOutline>
    </ButtonGroup>
  )
}
